import { render, staticRenderFns } from "./WholeService.vue?vue&type=template&id=a0126358&"
import script from "./WholeService.vue?vue&type=script&lang=ts&"
export * from "./WholeService.vue?vue&type=script&lang=ts&"
import style0 from "./WholeService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports